import { addDays, format } from 'date-fns';

import { QTask, TASK_NOT_STARTED, TASK_PRIORITY_MEDIUM, TASK_FREQUENCY, QTaskTag } from '@qwealth/qdata';
import { getPartnerShortCode } from '@qwealth/qcore';

import { Activity, QTaskComment } from '../models/Activity';
import { BASE_DATE_FORMAT, getCurrentDate } from './dateTimeHelper';
import { QTaskForm } from 'data/models/taskForm';

// TODO when qdata is updated, delete this and import
// update import in src/components/common/Activities/Form/AddTask/MainSectionAddAndEditMode.tsx
// remove related ts-ignore in src/components/common/Activities/Form/AddTask/MainSectionDisplayMode.tsx
export const TASK_TYPE = {
  standard: 'Standard',
  tradeRequest: 'Trade Request',
  kyc: 'KYC',
} as const;

export const DEFAULT_TASK: QTaskForm = {
  assignee: '',
  details: '',
  dueDate: getCurrentDate(),
  title: '',
  householdQID: null,
  isInternal: 1,
  partnerID: -1,
  status: TASK_NOT_STARTED,
  priority: TASK_PRIORITY_MEDIUM,
  isRecurring: false,
  frequency: TASK_FREQUENCY[0],
  startDate: getCurrentDate(),
  endDate: format(addDays(new Date(), 1), BASE_DATE_FORMAT),
  tags: [],
  taskTags: [],
  // @ts-ignore TODO remove when qdata is updated
  taskType: TASK_TYPE.standard,
};

export const DEFAULT_COMMENT: QTaskComment = {
  content: '',
  noteType: 'comment',
  taskId: -1,
  owners: [],
};

export const getTaskAttachmentPath = (householdId: string, id: string): string => {
  const shortCode = getPartnerShortCode(householdId);
  return `${shortCode}/${householdId}/Internal/Task Attachments/${id}/`;
};

export const isQTask = (activity: Activity): activity is QTask => {
  return 'status' in activity;
};

export const getTagKeys = (tags: QTaskTag[] | undefined): string[] => {
  return tags?.map(tag => tag.key) || [];
};

export const isTaskDeleted = (task: QTask): boolean => {
  return task.deletedFlag === 1;
};
